import { CommonModule } from '@angular/common';
import { NgModule, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { CheckoutMyHybridPackageComponent } from './my-hybrid-package.component';
import { InfoMessageModule } from 'src/app/shared/components/info-message/info-message.module';


@NgModule({
  imports: [
    CommonModule,
    MatButtonModule,
    
    InfoMessageModule
  ],
  exports: [
    CheckoutMyHybridPackageComponent
  ],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
  providers: [],
  declarations: [
    CheckoutMyHybridPackageComponent
  ]
})
export class CheckoutMyHybridPackageModule { }
